export enum CustomEventType {
  REDIRECTOR_EVENT = 'redirector-event',
  NO_SEARCH_RESULTS = 'no-search-results'
}
